import { useQuery } from "@tanstack/react-query";

export type FxRow = { date: string; base: string; quote: string; rate: number };

const FRANKFURTER = "https://api.frankfurter.dev/v2";

async function fetchJson(url: string): Promise<FxRow[]> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Frankfurter ${res.status}: ${url}`);
  return res.json();
}

export function useFxRates(fromDate: string, base: string, quotes: string[]) {
  const quotesParam = quotes.join(",");
  return useQuery({
    queryKey: ["fx-rates-daily", fromDate, base, quotesParam],
    queryFn: async () => {
      const url = `${FRANKFURTER}/rates?from=${fromDate}&base=${base}&quotes=${quotesParam}`;
      const daily = await fetchJson(url);
      return { daily };
    },
    staleTime: 60 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
  });
}

